import { Box } from '@chakra-ui/react';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { FullContainerSpinner } from 'components/ContainerSpinner';
import { TopNavbar } from 'components/TopNavbar';

/** Scrollable region below `TopNavbar`; keep in sync with any full-bleed views (e.g. pricing iframe). */
export const MAIN_CONTENT_AREA_HEIGHT = 'calc(100vh - 3.375rem)';

export const MainLayout: React.FC = () => {
  return (
    <Box maxW="full" minH="100vh">
      <TopNavbar />
      <Box className="main-content" h={MAIN_CONTENT_AREA_HEIGHT} overflow="auto">
        <Suspense fallback={<FullContainerSpinner />}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
};
